import { Route, Routes } from 'react-router-dom';
import { useState, lazy, Suspense } from 'react';
import React from "react";

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import '@aws-amplify/ui-react/styles.css'

import SiteNav from './components/common/SiteNav';
import SiteFooter from './components/common/SiteFooter';

import { ShopContextProvider } from './components/shop/Shop-context';

// Lazy load components
const Userpage = lazy(() => import('./components/home/Userpage'));
const Contacts = lazy(() => import('./components/contacts/Contacts'));
const LoginPage = lazy(() => import('./components/auth/LoginPage'));
const ValidatePage = lazy(() => import('./components/auth/ValidatePage'));
const LaunchAppstream = lazy(() => import('./components/Appstream/LaunchAppstream'));
const ForgotPassword = lazy(() => import('./components/auth/Forgotpassword'));
const Confirm = lazy(() => import('./components/auth/Confirm'));
const Changepassword = lazy(() => import('./components/auth/Changepassword'));
const ConfiSignIn = lazy(() => import('./components/auth/ConfiSignIn'));
const Cart = lazy(() => import('./components/shop/Cart').then(module => {
  return { default: module.Cart }
}));
const Shop = lazy(() => import('./components/shop/Shop').then(module => {
  return { default: module.Shop };
}));
// const Files = lazy(() => import('./components/home/files'));

// import HomePage from './components/home/HomePage';
// import Contacts from './components/contacts/Contacts';
// import LoginPage from './components/auth/LoginPage';
// import ValidatePage from './components/auth/ValidatePage';
// import LaunchAppstream from './components/Appstream/LaunchAppstream';
// import ForgotPassword from './components/auth/Forgotpassword';
// import Confirm from './components/auth/Confirm';
// import Changepassword from './components/auth/Changepassword';
// import ConfiSignIn from './components/auth/ConfiSignIn';

// import { Cart } from './components/shop/Cart';
// import { Shop } from "./components/shop/Shop";

Amplify.configure(awsExports);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Initialize state based on localStorage to persist across reloads
    return localStorage.getItem('isAuthenticated') === 'true';
  });

  function updateAuthStatus(authStatus) {
    setIsAuthenticated(authStatus)
    // Update localStorage to reflect the new authentication status
    localStorage.setItem('isAuthenticated', authStatus);
  }

  return (

    <div>
      <ShopContextProvider>
        <SiteNav isAuthenticated={isAuthenticated} updateAuthStatus={updateAuthStatus} />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path='/' element={<Shop />} />
            <Route path='/home' element={<Userpage isAuthenticated={isAuthenticated} />} />
            <Route path='/login' element={<LoginPage updateAuthStatus={updateAuthStatus} isAuthenticated={isAuthenticated}/>} />
            <Route path='/validate' element={<ValidatePage />} />
            <Route path='/passwordrecovery' element={<ForgotPassword />} />
            <Route path='/confirm' element={<Confirm />} />
            <Route path='/launch' element={<LaunchAppstream isAuthenticated={isAuthenticated} />} />
            <Route path='/changepassword' element={<Changepassword isAuthenticated={isAuthenticated} />} />
            <Route path='/confisignin' element={<ConfiSignIn updateAuthStatus={updateAuthStatus} />} />
            <Route path='/cart' element={<Cart />} />
            <Route path='/shop' element={<Shop />} />
            <Route path='*' element={<Shop />} />
          </Routes>
        </Suspense>
        <SiteFooter />
      </ShopContextProvider>
    </div>

  );
}

export default App;
